/**
 * Guardas de acesso por MÓDULO e NÍVEL (ADR 0013, issue #78).
 *
 * O menu já escondia o que o usuário não tem; isto fecha a porta na URL:
 *   <RotaModulo codigo="kanban">  — só renderiza se o módulo está liberado
 *   <RequerNivel modulo="radar_carteira" nivel="gestor"> — só se tem o nível
 * Quem não tem vê a página "Sem acesso" (nunca a tela vazia nem um redirect
 * mudo). Os níveis vêm de GET /auth/me (`niveis`), os módulos de /auth/me/modulos.
 * Gate de FRONT; o backend recusa com 403 de qualquer forma.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export function SemAcesso({ motivo }) {
  return (
    <div style={{ maxWidth: '520px', margin: '10vh auto', textAlign: 'center', color: 'var(--gray-700)' }}>
      <Lock size={40} color="var(--gray-400)" />
      <h2 style={{ margin: '12px 0 6px' }}>Sem acesso a esta tela</h2>
      <p style={{ color: 'var(--gray-500)' }}>{motivo || 'Seu perfil de acesso não libera este módulo.'} Se precisa dela, peça ao administrador em Administração › Usuários.</p>
      <Link to="/" className="btn btn-secondary" style={{ marginTop: '8px', display: 'inline-block' }}>Voltar ao início</Link>
    </div>
  );
}

export function RotaModulo({ codigo, children }) {
  const { user, acesso, podeModulo } = useAuth();
  if (!user) return null;
  if (!acesso.pronto) return <div className="loading"><div className="spinner" /></div>;
  if (!podeModulo(codigo)) return <SemAcesso />;
  return children;
}

export function RequerNivel({ modulo, nivel, children, fallback = null }) {
  const { user, acesso, temNivel } = useAuth();
  if (!user) return null;
  if (!acesso.pronto) return null;
  if (!temNivel(modulo, nivel)) return fallback;
  return children;
}
